var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.heroVideo)?_c('div',{staticClass:"header-video"},[_c('video',{attrs:{"src":_vm.heroVideo,"autoplay":"","loop":"","muted":"","playsinline":""},domProps:{"muted":true}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }